export default __webpack_public_path__ + "static/media/P545_CE.2a5b2a79.pdf";